import { useState } from 'react';
import { useParams } from 'react-router-dom';

import SingleVacancy from '../../../pages/recruiting/vacancySingle/singleVacancy';

import SectionContent from '../../../components/sectionContent/sectionContent';
import HeaderBtn from '../../../components/headerBtn/headerBtn';
import Sidebar from '../../../components/sidebar/Sidebar';

import '../../../scss/App.scss';
import {useSelector} from "react-redux";

const VacancySingleSection = () => {
	const { id } = useParams<{ id: string }>();
	const {inputValues} = useSelector((state: any) => state.recruiting.singleVacancy);
  const { claims } = useSelector((state: any) => state.user.user.data);

	const [overflowedBtnsCount] = useState<number>(0);

	let showBtn = false;
if (inputValues && (inputValues.status !== 'BY_MISTAKE' && inputValues.status !== 'FILLED')) {
	showBtn = inputValues.type === 'ON_ROUTE' || inputValues.type === 'PARTIAL_ROUTE';
	}

	const availableButtons = [
		showBtn &&
		(claims.includes('admin') || claims.includes('projects:routes:list')) && {
			component: (
				<HeaderBtn
					content="Настройки"
					purpose="vacantRoutesSettings"
					modalTitle="Настройки"
				/>
			),
		},
		(claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) && {
			component: (
				<HeaderBtn
					content='Сохранить'
					purpose='vacancyUpdate'
					modalTitle='Сохранение вакансии'
				/>
			),
		},
		(claims.includes('admin') || (claims.includes('recruiting:vacancy:edit') && claims.includes('projects:routes:list'))) && showBtn && {
			component: (
				<HeaderBtn
					content='Удалить маршрут'
					purpose='deleteRoute'
					modalTitle='Удаление маршрута'
				/>
			),
		},
		(claims.includes('admin') || (claims.includes('recruiting:vacancy:edit') && claims.includes('projects:routes:list'))) && showBtn && {
			component: (
				<HeaderBtn
					content='Добавить маршрут'
					purpose='addRouteOnVacancy'
					modalTitle='Добавление маршрута'
				/>
			),
		},
		{
			component: (
				<HeaderBtn
					content='Вернуться к списку'
					purpose='navigateToVacancyList'
					modalTitle='Переход к списку вакансий'
				/>
			),
		},
		(claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) && {
			component: (
				<HeaderBtn
					content='Снять выделения'
					purpose='removeSelections'
					modalTitle='Снятие выделения'
				/>
			),
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: any) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				pageName='recruitingSingle'
				section='Набор персонала'
				title='Вакансии'
				tail={'Вакансия №' + id}
				headBlockChildren={displayedHeadBtns}
			>
				<div className='content__single_report'>
					<div className='btns' style={{ margin: '0 0 7px 4px' }}>
					</div>
					<SingleVacancy />
				</div>
			</SectionContent>
		</div>
	);
};

export default VacancySingleSection;
